import './App.css';
import { ConfigProvider } from 'antd';
import { BrowserRouter as Router } from 'react-router-dom';
import ConfigRoutes from './layouts/ConfigRoutes';
import GlobalStyles from './styles/GlobalStyles/GlobalStyles';

function App() {
  return (
    <Router>
      <ConfigProvider
        theme={{
          token: {
            fontFamily: 'Noto Sans JP',
          },
        }}
      >
        <GlobalStyles>
          <ConfigRoutes />
        </GlobalStyles>
      </ConfigProvider>
    </Router>
  );
}

export default App;
